import MarkupText from '@app/components/MarkupText'
import { IComment } from '@app/models/Comment'
import * as React from 'react'

interface ICommentItemBodyProps {
  item: IComment
}

export default class CommentItemBody extends React.PureComponent<
  ICommentItemBodyProps
> {
  public render() {
    return (
      <div className='comment-item-body'>
        <MarkupText text={this.props.item.markup} />
      </div>
    )
  }
}
